import React from 'react';

import './Usage.css'

/** 
 * 使い方・説明コンポーネント
 */
function Usage() {

  return (
    <div className='Usage'>
      <h3>使い方</h3>
      <p>
        1. ベースとなる画像を選びます<br />
        2. 字幕設定で表示したい文字や文字色、左位置を設定します<br />
        3. プレビューを見ながら微調整します<br />
        4. 会心の一枚ができたら画像を保存します<br />
        5. 作成した画像はTwitter等で好きなようにお使いください
      </p>
      <h3>詳しい説明</h3>
      <p>
        テレビ放送で行われている字幕放送（正確には「文字多重放送」）を有効にしている際の画面表示を、
        擬似的に再現した画像を作成できるジョーク系Webアプリです。<br />
        実際のテレビ放送で使われているような表示を簡単に再現して、
        画像ファイル（PNGファイル）として保存できます。<br />
      </p>
      <p>
        すべての処理はブラウザ上（HTML, CSS, JavaScript）で完結しており、
        画像生成のための値（画像そのものや入力した文字など）はサーバーに送られることはありません。<br />
        高負荷になるような処理もしていないのでスマートフォンやタブレットなどでも利用可能ですが、
        PCブラウザに最適化して作成されているため、
        意図した位置に字幕が表示されない、レイアウトが崩れるなどの問題が発生することがあります。
      </p>
      <p>
        「画像を選択する」ボタンでお好きな画像をベース画像として利用できます。<br />
        画像の解像度等に制限はありませんが、
        容量の大きい画像や縦横の比率が16:9以外の画像では処理に支障が出たり、
        レイアウトが崩れたりすることがあります。
      </p>
      <p>
        字幕設定では「表示する文字列」「文字列の色」「左位置（表示開始位置）」を変更できます。<br />
        文字列の色は一般的な字幕放送で利用されている色（に相当する色）が選択できるようになっていますが、
        正確な色設定ではありません。<br />
        左位置は画像の左端から（画像の横幅に対して）5～95％の範囲で選択できますが、
        長い文字列を入力した状態で右側へ寄せすぎると字幕が右端からはみ出します。<br />
        縦位置は各段ごとの固定で、最大4段分の領域があります。
        下に寄せたい場合は3～4段目の字幕設定をご利用ください。
      </p>
      <p>
        「画像を保存する」ボタンで作成中の字幕付き画像をPNGファイルとして保存できます。<br />
        <u>※iOS版Chromeでは保存できないことが判明しています。iOSではSafariをご利用ください。</u>
      </p>
      <h3>よくある質問</h3>
      <p>
        Q. 無料で使用できますか？商用利用は可能ですか？<br />
        A. 無料で使用できますが、すべて自己責任でご利用ください。<br />
        A. 商用利用については止めませんが、商用であればちゃんとした専用のアプリを利用するのが良いと思います。
      </p>
      <p>
        Q. ○○できるようになりませんか？××できないのですが？<br />
        A. 一個人が趣味で作ったものなので、ご希望には添えない可能性が高いです。<br />
        A. ～～できない系の問い合わせについても、基本的に対応できません。
      </p>
      <h3>免責事項</h3>
      <p>
        本プログラムを利用したことによる不具合や損害については一切の責任を負いません。<br />
        また、本プログラム利用者が本プログラムの利用を通じて他者に損害を与えた場合、利用者は、自らの責任において問題を解決するものとします。<br />
      </p>
      <h3>作者</h3>
      <p>
        なのなの（Nano-Nano）<br />
        ※問い合わせはサイト下部のTwitterからどうぞ。
      </p>
      <h3>更新履歴</h3>
      <p>
        2021/02/07 : 公開開始<br />
        2021/03/20 : 画像のドラッグ＆ドロップ対応、表示したい文字列を消すボタンを追加<br />
        2022/01/27 : 画像保存時に処理中のローディング表示を行うよう修正
      </p>
    </div>
  );
}

export default Usage;